<form [formGroup]="sellingForm">
  @for (field of objectKeys(fieldList); track field) {
    <ng-container dynamicField [field]="fieldList[field]" [group]="sellingForm">
    </ng-container>
  }
</form>
